/***************************************************
 * Formatters from ha-mytriplogic.js
 **************************************************/

function FormatPrice(price, flgPerPerson) {
    var abs = Math.abs(price);
    //if (price < 0)
    //    abs = Math.floor(abs);
    //else if (price > 0)
    //    abs = Math.ceil(abs);
    abs = Math.ceil(abs);

    var format = numeral(abs).format("0,0");
    //var prefix = "kr. ";
    //var prefix = AppData.Currency.Symbol;
    var prefix = "";
    format = AppData.Currency.Pattern.replace("n", format).replace("$", AppData.Currency.Symbol)

    var sufix = "";
    if (flgPerPerson) {
        sufix = " " + AppData.Translations["pr-person"];
    }
    if(price == 0)
        return AppData.Translations["same-price"];
    else if (price > 0)
        return "+ " + prefix + format + sufix;
    else
        return "- " + prefix + format + sufix;
};
global.FormatPrice = FormatPrice;

function FormatTotalPrice(price, withoutCurrency) {
    //return "kr. " + numeral(price).format("0,0");
    var format = numeral(Math.ceil(price)).format("0,0");
    if (withoutCurrency)
        return format; //",-"

    format = AppData.Currency.Pattern.replace("n", format).replace("$", AppData.Currency.Symbol)
    return format;
};
global.FormatTotalPrice = FormatTotalPrice;
function LocaleFormatPrice(price) {
    //return numeral(price).format("0,0.0[0000]");  // 12,456.025
    return numeral(price).format("0.[00000]");      //  12456.025
    //return numeral(price).value().toLocaleString(AppData.CurrentLocaleCountry2);
};
global.LocaleFormatPrice = LocaleFormatPrice;


function FormatFlightTimeString(string) {
    var mom = moment(string, "YYYY-MM-DDTHH:mm");
    return mom.format("HH:mm")
};
global.FormatFlightTimeString = FormatFlightTimeString;

function FormatFlightDateString(string) {
    var mom = moment(string, "YYYY-MM-DDTHH:mm");
    return mom.format("L HH:mm")
};
global.FormatFlightDateString = FormatFlightDateString;

function FormatDateString(string) {
    var mom = moment(string, "YYYY-MM-DD");
    return mom.format("DD.MM.YYYY")
};
global.FormatDateString = FormatDateString;

function FormatFlightTime(mins) {
    var hours = Math.floor(mins / 60);
    var minutes = mins - (hours * 60);

    if ((minutes + "").length == 1)
        minutes = '0' + minutes;

    return hours + 'h ' + minutes + "m";
};
global.FormatFlightTime = FormatFlightTime;

function FormatFlightTime2(mins) {
    var hours = Math.floor(mins / 60);
    var minutes = mins - (hours * 60);

    if ((hours + "").length == 1)
        hours = '0' + hours;

    if ((minutes + "").length == 1)
        minutes = '0' + minutes;

    return hours + ':' + minutes;
};
global.FormatFlightTime2 = FormatFlightTime2;

function FormatTravelTime(seconds) {
    var mins = 0;
    if (mins) {
        mins = Math.ceil(seconds / 60 / 5) * 5;
    }
    var hours = Math.floor(mins / 60);
    var minutes = mins - (hours * 60);

    if ((hours + "").length == 1)
        hours = '0' + hours;

    if ((minutes + "").length == 1)
        minutes = '0' + minutes;

    return hours + ':' + minutes;
};
global.FormatTravelTime = FormatTravelTime;

function FormatOnlyDate(data) {
    return moment(data).format("L");
};
global.FormatOnlyDate = FormatOnlyDate;

function FormatOnlyDateISO(data) {
    return moment(data).format("YYYY-MM-DD");
};
global.FormatOnlyDateISO = FormatOnlyDateISO;

function FormatOnlyDateString(string, withoutYear) {
    if (!string) return "";
    var mom = moment(string, "YYYY-MM-DD");
    if (withoutYear) {
        var noYearLocaleFormat = moment.localeData().longDateFormat('L')
            .replace(/[-,\\./]*\s*Y+[-,\\./]*\s*/, '');
        return mom.format(noYearLocaleFormat);
    } else {
        return mom.format("L");
    }
};
global.FormatOnlyDateString = FormatOnlyDateString;

function FormatDateRange(fromDate, toData) {
    return (moment(fromDate).format("DD. MMM.") + " - "+ moment(toData).format("DD. MMM. YY"));
};
global.FormatDateRange = FormatDateRange;

function FormatOnlyTimeString(string) {
    if (!string) return "";
    var mom = moment(string, "HH:mm");
    return mom.format("LT");
};
global.FormatOnlyTimeString = FormatOnlyTimeString;

function FormatInsertYearInString(string, data)
{
    return string.replaceAll("%YEAR%", data.getFullYear());
};
global.FormatInsertYearInString = FormatInsertYearInString;


function FormatDistance(distance) {
    if (!distance || distance < 0) return "-- km";

    return "" + distance + " km";
};
global.FormatDistance = FormatDistance;


/***************************************************
 * Formatters from ha-packagelogic.js
 **************************************************/

function GetFormattedYear(date) {
    if (!date || date == "")
        return "";
    var mom = moment(date);
    return mom.format("YYYY");
};
global.GetFormattedYear = GetFormattedYear;

function GetFormattedDayOfMonth(date) {
    if (!date || date == "")
        return "";
    var mom = moment(date);
    return mom.format("D");
};
global.GetFormattedDayOfMonth = GetFormattedDayOfMonth;

function GetFormattedDays(days) {
    if (!days)
        return "";
    var txt = AppData.Translations["day"];
    if (Math.abs(days) > 1)
        txt = AppData.Translations["days"];
    return String.format("{0} {1}", days, txt);
};
global.GetFormattedDays = GetFormattedDays;

function GetFormattedNights(nights) {
    if (!nights)
        return "";
    var txt = AppData.Translations["night"];
    if (Math.abs(nights) > 1)
        txt = AppData.Translations["nights"];
    return String.format("{0} {1}", nights, txt);
};
global.GetFormattedNights = GetFormattedNights;